export const whatsAppTemplate = [
    {
        templateUniqueKey: 'APPOINTMENT_TEMPLATE',
        label: 'Appointment Confirmation',
        checked:false
    },
    {
        templateUniqueKey: 'PATIENT_FEEDBACK_TEMPLATE',
        label:'Feedback Request',
        checked:false
    },
    {
        templateUniqueKey: 'PATIENT_FOLLOW_UP_APPOINTMENT_REMINDER_TEMPLATE',
        label: 'Follow-up Notification ',
        checked:false
    },
    // {
    //     templateUniqueKey: 'PATIENT_INVOICE_TEMPLATE',
    //     label:'Invoice creation',
    //     checked:false
    // },
    // {
    //     templateUniqueKey: 'DOCTOR_PRESCRIPTION_TEMPLATE',
    //     label: 'Prescription Generation',
    //     checked:false
    // },
    {
        templateUniqueKey: 'QUEUE_STATUS_UPDATE_TEMPLATE',
        label:'Queue Update (Every change in your queue no.)',
        checked:false
    },
    {
        templateUniqueKey: 'QUEUE_STATUS_QUEUE_END',
        label:'Queue end (Your turn)',
        checked:false
    },
    {
        templateUniqueKey: 'NEW_GENERALISED_MEDICAL_DOCUMENTS_INVOICE',
        label:'Invoice attachment',
        checked:false
    },
    {
        templateUniqueKey: 'NEW_GENERALISED_MEDICAL_DOCUMENTS_PRESCRIPTION',
        label:'Prescription attachment',
        checked:false
    },
];





